export const bonuses = [
  {
    number: 1,
    title: 'Maxillary Expansion Visual Guide™',
    value: 19,
    description:
      'A visual guide to the fundamentals of transverse maxillary assessment and expansion concepts.',
    topics: [
      'Transverse maxillary deficiency.',
      'Posterior crossbite assessment.',
      'Expansion appliance categories.',
      'Skeletal maturity considerations.',
      'Educational diagrams and comparison charts.',
    ],
    closing:
      'Understand the principles behind maxillary expansion through a focused visual reference.',
    image: 'https://cdn.magicpatterns.com/uploads/cyozdCMKzjMBAgzRYgLHkG/BONUS_1_MAXILLAR-EN.png',
  },
  {
    number: 2,
    title: 'Functional Orthopedic Appliance Atlas™',
    value: 24,
    description:
      'An illustrated educational atlas covering commonly studied functional orthopedic appliances.',
    topics: [
      'Functional appliance categories.',
      'General indications and limitations.',
      'Biomechanical principles.',
      'Appliance comparison tables.',
      'Illustrated reference diagrams.',
    ],
    closing:
      'Build a stronger conceptual understanding of functional orthopedic appliance systems.',
    image: 'https://cdn.magicpatterns.com/uploads/bboeffGBvfeo1PmcPS56ks/BONUS_2_MAXILLAR-EN.png',
  },
  {
    number: 3,
    title: 'Skeletal Class II & III Assessment Maps™',
    value: 21,
    description: 'A specialized visual reference for studying sagittal skeletal discrepancies.',
    topics: [
      'Skeletal Class II assessment concepts.',
      'Skeletal Class III assessment concepts.',
      'Maxillary versus mandibular contributions.',
      'Cephalometric interpretation considerations.',
      'Comparative clinical scenarios.',
    ],
    closing: 'Organize your understanding of two major skeletal discrepancy patterns.',
    image: 'https://cdn.magicpatterns.com/uploads/bUiz4mbHzy8rzwQMAejPf9/BONUS_3_MAXILLAR-EN.png',
  },
  {
    number: 4,
    title: 'Pediatric Dentofacial Red Flags Checklist™',
    value: 17,
    description:
      'A practical educational checklist covering developmental findings that may require closer evaluation.',
    topics: [
      'Eruption-related observations.',
      'Transverse discrepancies.',
      'Facial asymmetry considerations.',
      'Functional and occlusal findings.',
      'Referral and further-assessment considerations.',
    ],
    closing:
      'A concise reference for recognizing findings that deserve additional clinical attention.',
    image: 'https://cdn.magicpatterns.com/uploads/gCHSYdMvfa7bEDh2PxLvVt/BONUS_4_MAXILLAR-EN.png',
  },
  {
    number: 5,
    title: 'Growth Monitoring & Clinical Records Workbook™',
    value: 27,
    description:
      'A printable workbook for organizing growth-related clinical observations and educational case reviews.',
    topics: [
      'Initial assessment forms.',
      'Growth observation records.',
      'Skeletal relationship worksheets.',
      'Longitudinal comparison templates.',
      'Educational case review pages.',
    ],
    closing:
      'Keep growth-related information organized in one consistent documentation framework.',
    image: 'https://cdn.magicpatterns.com/uploads/9cZ7CkrX4jJqyMqHWgJwJh/BONUS_5_MAXILLAR-EN.png',
  },
];
